import axios from 'axios';

import {
  API_BASE_URL,
  MAX_RETRY_COUNT,
  HTTP_STATUS,
} from '../constants';

import { logError } from '../common/utils/logger';

/**
 * =========================
 * NO OAUTH TOKEN LOGIC
 * =========================
 * BFF handles authentication server-side
 */
export const getAuthToken = async () => {
  return null;
};

/**
 * =========================
 * CSRF HANDLER (ONLY REQUIRED PART)
 * =========================
 */
const attachCsrf = (config) => {
  if (!config.headers) config.headers = {};

  if (window.Liferay?.authToken) {
    config.headers['X-CSRF-Token'] = window.Liferay.authToken;
  }
};

/**
 * =========================
 * FORM DATA HANDLING
 * =========================
 */
const prepareFormDataHeaders = (config) => {
  if (config.data instanceof FormData && config.headers) {
    delete config.headers['Content-Type'];
    delete config.headers['content-type'];
    config.transformRequest = [];
  }
};

/**
 * =========================
 * REQUEST INTERCEPTOR (BFF ONLY)
 * =========================
 */
const attachAuth = async (config) => {
  config.headers = config.headers || {};

  prepareFormDataHeaders(config);

  // Only CSRF + cookies (BFF responsibility)
  attachCsrf(config);

  return config;
};

/**
 * =========================
 * AXIOS INSTANCE
 * =========================
 */
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true // REQUIRED for BFF session cookies
});

api.interceptors.request.use(attachAuth, Promise.reject);

/**
 * =========================
 * RESPONSE HANDLER
 * =========================
 */
const handleResponseError = async (error) => {
  const { response, config } = error;

  if (!response || !config) {
    return Promise.reject(error);
  }

  config._retryCount = config._retryCount || 0;

  // BFF handles auth → just retry safe requests
  if (
    (response.status === HTTP_STATUS.UNAUTHORIZED ||
      response.status === HTTP_STATUS.FORBIDDEN) &&
    config._retryCount < MAX_RETRY_COUNT
  ) {
    config._retryCount += 1;
    return api(config);
  }

  logError('[API] Request failed', {
    url: config.url,
    status: response.status,
    data: response.data
  });

  return Promise.reject(error);
};

api.interceptors.response.use(
  (res) => res,
  handleResponseError
);

/**
 * =========================
 * EXPORT
 * =========================
 */
export default api;